import sendRequest from "./sendRequest";

export const completeProvisioning = (unique_id, bt_name, provisioning_token) => {
    const data = {
        'unique_id': unique_id,
        'bt_name': bt_name,
        'provisioning_token': provisioning_token
    }
    return sendRequest("/complete_provisioning", "POST", true, data);
}
